"use client";
// import { ResumeData } from "@/lib/schema";

// // Helper function to handle both old and new language formats
// const getLanguageName = (lang: string | { name: string }): string => {
//   return typeof lang === 'string' ? lang : lang.name;
// };

// // Helper function to get initials from name
// const getInitials = (name: string): string => {
//   return name
//     .split(' ')
//     .map(word => word.charAt(0))
//     .join('')
//     .toUpperCase()
//     .slice(0, 2);
// };

// // Helper function to render language proficiency dots
// const renderProficiencyDots = (level?: string) => {
//   const maxDots = 5;
//   let filledDots = 3; // Default to 3 dots if no level specified
  
//   if (level) {
//     const lowerLevel = level.toLowerCase();
//     if (lowerLevel.includes('native') || lowerLevel.includes('fluent') || lowerLevel === 'advanced') {
//       filledDots = 5;
//     } else if (lowerLevel.includes('intermediate') || lowerLevel === 'proficient') {
//       filledDots = 4;
//     } else if (lowerLevel.includes('basic') || lowerLevel === 'beginner') {
//       filledDots = 2;
//     }
//   }

//   return (
//     <div className="flex gap-1">
//       {[...Array(maxDots)].map((_, i) => (
//         <div
//           key={i}
//           className={`w-2 h-2 rounded-full ${
//             i < filledDots ? 'bg-blue-500' : 'bg-gray-300'
//           }`}
//         />
//       ))}
//     </div>
//   );
// };

// export default function ProfessionalSidebar({ data }: { data: ResumeData }) {
//   return (
//     <div className="flex bg-white text-gray-800 min-h-full">
//       {/* Main Content - Left Column */}
//       <div className="flex-1 p-8 pr-4">
//         {/* Header */}
//         <div className="mb-8">
//           <h1 className="text-4xl font-bold text-gray-900 mb-2">{data.basics.name}</h1>
//           <h2 className="text-xl text-blue-600 font-medium mb-4">{data.basics.title}</h2>
          
//           <div className="flex flex-wrap gap-4 text-sm text-gray-600">
//             {data.basics.phone && (
//               <div className="flex items-center gap-1">
//                 <span>📞</span>
//                 <span>{data.basics.phone}</span>
//               </div>
//             )}
//             {data.basics.email && (
//               <div className="flex items-center gap-1">
//                 <span>✉️</span>
//                 <span>{data.basics.email}</span>
//               </div>
//             )}
//             {data.basics.location && (
//               <div className="flex items-center gap-1">
//                 <span>📍</span>
//                 <span>{data.basics.location}</span>
//               </div>
//             )}
//             {data.basics.social && data.basics.social.length > 0 && (
//               <div className="flex items-center gap-1">
//                 <span>🔗</span>
//                 <a 
//                   href={data.basics.social[0].url} 
//                   className="text-blue-600 hover:underline"
//                   target="_blank" 
//                   rel="noopener noreferrer"
//                 >
//                   {data.basics.social[0].url}
//                 </a>
//               </div>
//             )}
//           </div>
//         </div>

//         {/* Summary Section */}
//         {data.basics.summary && (
//           <div className="mb-8">
//             <h3 className="text-lg font-bold text-gray-900 mb-3 pb-2 border-b-2 border-gray-900">
//               SUMMARY
//             </h3>
//             <p className="text-sm leading-relaxed text-gray-700">{data.basics.summary}</p>
//           </div>
//         )}

//         {/* Experience Section */}
//         <div className="mb-8">
//           <h3 className="text-lg font-bold text-gray-900 mb-4 pb-2 border-b-2 border-gray-900">
//             EXPERIENCE
//           </h3>
//           {data.experience.map((exp, i) => (
//             <div key={i} className="mb-6">
//               <h4 className="text-base font-semibold text-gray-900">{exp.role}</h4>
//               <h5 className="text-sm font-medium text-blue-600 mb-2">{exp.company}</h5>
//               <div className="flex items-center gap-2 text-xs text-gray-600 mb-3">
//                 <span>📅</span>
//                 <span>{exp.startDate} - {exp.current ? 'Present' : exp.endDate}</span>
//               </div>
//               {exp.summary && (
//                 <div className="text-sm text-gray-700">
//                   <p className="mb-2">{exp.company}</p>
//                   <ul className="list-disc list-inside space-y-1 text-xs">
//                     {exp.summary.split('\n').map((line, idx) => (
//                       line.trim() && <li key={idx}>{line.trim()}</li>
//                     ))}
//                   </ul>
//                 </div>
//               )}
//             </div>
//           ))}
//         </div>

//         {/* Education Section */}
//         <div className="mb-8">
//           <h3 className="text-lg font-bold text-gray-900 mb-4 pb-2 border-b-2 border-gray-900">
//             EDUCATION
//           </h3>
//           {data.education.map((edu, i) => (
//             <div key={i} className="mb-4">
//               <h4 className="text-base font-semibold text-gray-900">{edu.degree}</h4>
//               <h5 className="text-sm font-medium text-blue-600 mb-2">{edu.institution}</h5>
//               <div className="flex items-center gap-2 text-xs text-gray-600">
//                 <span>📅</span>
//                 <span>{edu.startDate} - {edu.endDate}</span>
//               </div>
//             </div>
//           ))}
//         </div>
//       </div>

//       {/* Sidebar - Right Column */}
//       <div className="w-80 bg-gray-50 p-8 pl-4">
//         {/* Profile Photo */}
//         <div className="flex justify-center mb-8 print:overflow-visible">
//           {data.basics.photo ? (
//             <img
//               src={data.basics.photo}
//               alt="Profile"
//               className="w-24 h-24 rounded-full object-cover border-4 border-blue-500 print:max-w-24 print:max-h-24 print:object-cover print:border print:border-gray-400 print:shadow-none"
//             />
//           ) : (
//             <div className="w-24 h-24 rounded-full bg-blue-500 flex items-center justify-center text-white text-xl font-bold print:border print:border-gray-400">
//               {getInitials(data.basics.name || "JS")}
//             </div>
//           )}
//         </div>

//         {/* Strengths Section - Only show if data exists */}
//         {data.basics.strengths && data.basics.strengths.length > 0 && (
//           <div className="mb-8">
//             <h3 className="text-lg font-bold text-gray-900 mb-4 pb-2 border-b-2 border-gray-900">
//               STRENGTHS
//             </h3>
//             <div className="space-y-3">
//               {data.basics.strengths.map((strength, i) => (
//                 <div key={i}>
//                   <div className="flex items-center gap-2 mb-2">
//                     <span className="text-blue-500">🏆</span>
//                     <span className="text-sm font-medium">{strength.title}</span>
//                   </div>
//                   {strength.description && (
//                     <p className="text-xs text-gray-600">{strength.description}</p>
//                   )}
//                 </div>
//               ))}
//             </div>
//           </div>
//         )}

//         {/* Key Achievements Section - Only show if data exists */}
//         {data.basics.achievements && data.basics.achievements.length > 0 && (
//           <div className="mb-8">
//             <h3 className="text-lg font-bold text-gray-900 mb-4 pb-2 border-b-2 border-gray-900">
//               KEY ACHIEVEMENTS
//             </h3>
//             <div className="space-y-3">
//               {data.basics.achievements.map((achievement, i) => (
//                 <div key={i}>
//                   <div className="flex items-center gap-2 mb-2">
//                     <span className="text-blue-500">🚀</span>
//                     <span className="text-sm font-medium">{achievement.title}</span>
//                   </div>
//                   {achievement.description && (
//                     <p className="text-xs text-gray-600">{achievement.description}</p>
//                   )}
//                 </div>
//               ))}
//             </div>
//           </div>
//         )}

//         {/* Languages Section */}
//         {data.basics.languages && data.basics.languages.length > 0 && (
//           <div className="mb-8">
//             <h3 className="text-lg font-bold text-gray-900 mb-4 pb-2 border-b-2 border-gray-900">
//               LANGUAGES
//             </h3>
//             <div className="space-y-3">
//               {data.basics.languages.map((lang, i) => {
//                 const langName = getLanguageName(lang as string | { name: string });
//                 const langObj = typeof lang === 'object' && lang !== null ? lang as { name: string; level?: string } : null;
//                 return (
//                   <div key={i} className="flex justify-between items-center">
//                     <div>
//                       <div className="text-sm font-medium text-gray-900">{langName}</div>
//                       {/* <div className="text-xs text-gray-600">
//                         {langObj && langObj.level ? langObj.level : 'Native'}
//                       </div> */}
//                     </div>
//                     {/* {renderProficiencyDots(langObj?.level)} */}
//                   </div>
//                 );
//               })}
//             </div>
//           </div>
//         )}

//         {/* Skills Section */}
//         <div className="mb-8">
//           <h3 className="text-lg font-bold text-gray-900 mb-4 pb-2 border-b-2 border-gray-900">
//             SKILLS
//           </h3>
//           <div className="flex flex-wrap gap-2">
//             {data.skills.map((skill, i) => (
//               <span
//                 key={i}
//                 className="px-3 py-1 bg-gray-200 text-gray-700 text-xs font-medium rounded"
//               >
//                 {skill}
//               </span>
//             ))}
//           </div>
//         </div>

//         {/* Social Links */}
//         {data.basics.social && data.basics.social.length > 1 && (
//           <div className="mb-8">
//             <h3 className="text-lg font-bold text-gray-900 mb-4 pb-2 border-b-2 border-gray-900">
//               SOCIAL LINKS
//             </h3>
//             <div className="space-y-2">
//               {data.basics.social.slice(1).map((link, i) => (
//                 <div key={i} className="text-xs">
//                   <span className="font-medium text-gray-900">{link.label}:</span>{" "}
//                   <a 
//                     href={link.url} 
//                     className="text-blue-600 hover:underline break-all"
//                     target="_blank" 
//                     rel="noopener noreferrer"
//                   >
//                     {link.url}
//                   </a>
//                 </div>
//               ))}
//             </div>
//           </div>
//         )}

//         {/* Hobbies & Interests */}
//         {data.basics.hobbies && data.basics.hobbies.length > 0 && (
//           <div>
//             <h3 className="text-lg font-bold text-gray-900 mb-4 pb-2 border-b-2 border-gray-900">
//               HOBBIES & INTERESTS
//             </h3>
//             <p className="text-xs text-gray-700">{data.basics.hobbies.join(", ")}</p>
//           </div>
//         )}
//       </div>
//     </div>
//   );
// }


import React from "react";
import { ResumeData } from "@/lib/schema";

const getLanguageName = (lang: string | { name: string }): string =>
  typeof lang === "string" ? lang : lang.name;

const getInitials = (name: string): string => {
  return name
    .split(" ")
    .map(word => word.charAt(0))
    .join("")
    .toUpperCase()
    .slice(0, 2);
};

// Main color variables
const colors = {
  primary: "#124191",
  divider: "#212846",
  border: "#e5e7eb",
  sidebarBg: "#fcfdff",
  tagBg: "#eceff4",
  tagText: "#363c53",
  blueAccent: "#246dcf",
};

const styles = {
  wrapper: {
    display: "flex",
    background: "#fff",
    color: "#20263a",
    fontFamily: "'Segoe UI', Arial, sans-serif",
    minHeight: "100vh",
    width: "100%",
  } as React.CSSProperties,
  left: {
    flex: 1,
    padding: "38px 36px 20px 48px",
    minWidth: 0,
    display: "flex",
    flexDirection: "column" as const,
  },
  right: {
    width: 320,
    background: colors.sidebarBg,
    padding: "38px 34px 24px 34px",
    borderLeft: `1px solid ${colors.border}`,
    display: "flex",
    flexDirection: "column" as const,
    minHeight: "100vh",
    minWidth: 260,
    boxSizing: "border-box" as const,
  },
  header: {
    marginBottom: 8,
  },
  name: {
    fontSize: 32,
    fontWeight: 700,
    marginBottom: 3,
    color: "#1d2231",
  },
  title: {
    fontSize: 18,
    fontWeight: 500,
    color: colors.blueAccent,
    marginBottom: 10,
  },
  contactRow: {
    display: "flex",
    flexWrap: "wrap" as const,
    gap: "18px",
    marginBottom: "10px",
    fontSize: 14,
    color: "#353a45",
  },
  contactLink: {
    color: colors.blueAccent,
    textDecoration: "none",
    wordBreak: "break-all" as const,
  },
  section: {
    marginBottom: 10,
  },
  sectionTitle: {
    fontSize: 15,
    fontWeight: 700,
    letterSpacing: 0.7,
    color: "#162245",
    marginBottom: 9,
    borderBottom: `2px solid ${colors.divider}`,
    paddingBottom: 6,
    textTransform: "uppercase" as const,
  },
  summary: {
    fontSize: 14,
    color: "#212846",
    lineHeight: 1.69,
    marginBottom: 10,
  },
  expRole: {
    fontWeight: 600,
    fontSize: 16,
    marginBottom: 1,
    color: "#18244d",
  },
  expCompany: {
    fontWeight: 500,
    fontSize: 14,
    color: colors.blueAccent,
    marginBottom: 2,
  },
  expDates: {
    fontWeight: 400,
    fontSize: 12,
    color: "#707e9c",
    marginBottom: 9,
  },
  expSummary: {
    fontSize: 13,
    color: "#1a2337",
    marginBottom: 6,
  },
  expBulletList: {
    fontSize: 13,
    color: "#1a2337",
    paddingLeft: 0,
    margin: "5px 0",
  },
  eduDegree: {
    fontWeight: 600,
    fontSize: 15,
    color: "#1a2337",
    marginBottom: 2,
  },
  eduInstitution: {
    color: colors.blueAccent,
    fontSize: 13.5,
    marginBottom: 1,
  },
  eduDates: {
    fontSize: 12,
    color: "#707e9c",
    marginBottom: 8,
  },
  photoWrap: {
    display: "flex",
    justifyContent: "center",
    marginBottom: 26,
  },
  profilePhoto: {
    width: "96px",
    height: "96px",
    borderRadius: "50%",
    objectFit: "cover" as const,
    border: `4px solid ${colors.blueAccent}`,
    background: "#e5e7eb",
  },
  initialPhoto: {
    width: "96px",
    height: "96px",
    borderRadius: "50%",
    background: colors.blueAccent,
    color: "#fff",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: 36,
    fontWeight: 700,
    border: `4px solid ${colors.blueAccent}`,
  },
  sidebarSection: {
    marginBottom: 29,
  },
  sidebarSectionTitle: {
    fontSize: 15,
    fontWeight: 700,
    color: "#162245",
    marginBottom: 10,
    paddingBottom: 6,
    borderBottom: `2px solid ${colors.divider}`,
    textTransform: "uppercase" as const,
    letterSpacing: 0.7,
  },
  strengthsItem: {
    marginBottom: 14,
  },
  strengthsTitle: {
    fontWeight: 600,
    color: "#1d2231",
    fontSize: 14,
    display: "flex",
    alignItems: "center",
    gap: "5px",
  },
  strengthsDesc: {
    fontSize: 12,
    color: "#53617b",
    marginTop: 2,
  },
  achievementsTitle: {
    fontWeight: 600,
    color: "#1d2231",
    fontSize: 14,
    display: "flex",
    alignItems: "center",
    gap: "5px",
  },
  achievementsDesc: {
    fontSize: 12,
    color: "#53617b",
    marginTop: 2,
  },
  langItem: {
    fontSize: 14,
    color: "#1d2337",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    marginBottom: 6,
  },
  tagWrap: {
    display: "flex",
    flexWrap: "wrap" as const,
    gap: "7px",
  },
  tagItem: {
    background: colors.tagBg,
    color: colors.tagText,
    fontSize: 12.5,
    fontWeight: 500,
    padding: "5px 13px",
    borderRadius: "5px",
    marginBottom: 6,
    marginRight: 2,
    display: "inline-block",
  },
  socialLinks: { fontSize: 12, marginBottom: 3 },
  hobbyText: { fontSize: 12.5, color: "#41506d" },
};

export default function ProfessionalSidebar({ data }: { data: ResumeData }) {
  return (
    <div style={styles.wrapper}>
      {/* Main Content - Left Column */}
      <div style={styles.left}>
        {/* Header */}
        <div style={styles.header}>
          <h1 style={styles.name}>{data.basics.name}</h1>
          <h2 style={styles.title}>{data.basics.title}</h2>
          <div style={styles.contactRow}>
            {data.basics.phone && (
              <span>📞 {data.basics.phone}</span>
            )}
            {data.basics.email && (
              <span>✉️ {data.basics.email}</span>
            )}
            {data.basics.location && (
              <span>📍 {data.basics.location}</span>
            )}
            {data.basics.social && data.basics.social[0] && (
              <a href={data.basics.social[0].url} style={styles.contactLink} target="_blank" rel="noopener noreferrer">
                🔗 {data.basics.social[0].url}
              </a>
            )}
          </div>
        </div>

        {/* Summary */}
        {data.basics.summary && (
          <div style={styles.section}>
            <div style={styles.sectionTitle}>SUMMARY</div>
            <div style={styles.summary}>{data.basics.summary}</div>
          </div>
        )}

        {/* Experience */}
        <div style={styles.section}>
          <div style={styles.sectionTitle}>EXPERIENCE</div>
          {data.experience.map((exp, i) => (
            <div key={i} style={{ marginBottom: 12 }}>
              <div style={styles.expRole}>{exp.role}</div>
              <div style={styles.expCompany}>{exp.company}</div>
              <div style={styles.expDates}>📅 {exp.startDate} - {exp.current ? "Present" : exp.endDate}</div>
              {exp.summary && (
                <div>
                  {exp.company && <div style={styles.expSummary}>{exp.company}</div>}
                  <ul style={styles.expBulletList}>
                  <li>  {exp.summary}</li>
                   
                  </ul>
                </div>
              )}
            </div>
          ))}
        </div>

        {/* Education */}
        <div style={styles.section}>
          <div style={styles.sectionTitle}>EDUCATION</div>
          {data.education.map((edu, i) => (
            <div key={i} style={{ marginBottom: 12 }}>
              <div style={styles.eduDegree}>{edu.degree}</div>
              <div style={styles.eduInstitution}>{edu.institution}</div>
              <div style={styles.eduDates}>📅 {edu.startDate} - {edu.endDate}</div>
            </div>
          ))}
        </div>
      </div>

      {/* Sidebar - Right Column */}
      <div style={styles.right}>
        <div style={styles.photoWrap}>
          {data.basics.photo ? (
            <img src={data.basics.photo} alt="Profile pic" style={styles.profilePhoto} />
          ) : (
            <div style={styles.initialPhoto}>{getInitials(data.basics.name || "JS")}</div>
          )}
        </div>

        {/* Strengths */}
        {data.basics.strengths && data.basics.strengths.length > 0 && (
          <div style={styles.sidebarSection}>
            <div style={styles.sidebarSectionTitle}>STRENGTHS</div>
            {data.basics.strengths.map((strength, i) => (
              <div key={i} style={styles.strengthsItem}>
                <div style={styles.strengthsTitle}>🏆 {strength.title}</div>
                {strength.description && (
                  <div style={styles.strengthsDesc}>{strength.description}</div>
                )}
              </div>
            ))}
          </div>
        )}

        {/* Key Achievements */}
        {data.basics.achievements && data.basics.achievements.length > 0 && (
          <div style={styles.sidebarSection}>
            <div style={styles.sidebarSectionTitle}>KEY ACHIEVEMENTS</div>
            {data.basics.achievements.map((achievement, i) => (
              <div key={i} style={styles.strengthsItem}>
                <div style={styles.achievementsTitle}>🚀 {achievement.title}</div>
                {achievement.description && (
                  <div style={styles.achievementsDesc}>{achievement.description}</div>
                )}
              </div>
            ))}
          </div>
        )}

        {/* Languages */}
        {data.basics.languages && data.basics.languages.length > 0 && (
          <div style={styles.sidebarSection}>
            <div style={styles.sidebarSectionTitle}>LANGUAGES</div>
            {data.basics.languages.map((lang, i) => (
              <div key={i} style={styles.langItem}>
                <span>{getLanguageName(lang)}</span>
              </div>
            ))}
          </div>
        )}

        {/* Skills */}
        <div style={styles.sidebarSection}>
          <div style={styles.sidebarSectionTitle}>SKILLS</div>
          <div style={styles.tagWrap}>
            {data.skills.map((skill, i) => (
              <span key={i} style={styles.tagItem}>{skill}</span>
            ))}
          </div>
        </div>

        {/* Social Links */}
        {data.basics.social && data.basics.social.length > 1 && (
          <div style={styles.sidebarSection}>
            <div style={styles.sidebarSectionTitle}>SOCIAL LINKS</div>
            <div style={styles.socialLinks}>
              {data.basics.social.slice(1).map((link, i) => (
                <div key={i}>
                  <span style={{ fontWeight: 600 }}>{link.label}:</span>{" "}
                  <a href={link.url} style={styles.contactLink} target="_blank" rel="noopener noreferrer">
                    {link.url}
                  </a>
                </div>
              ))}
            </div>
          </div>
        )}

        {/* Hobbies & Interests */}
        {data.basics.hobbies && data.basics.hobbies.length > 0 && (
          <div style={{ ...styles.sidebarSection, marginBottom: 0 }}>
            <div style={styles.sidebarSectionTitle}>HOBBIES & INTERESTS</div>
            <div style={styles.hobbyText}>{data.basics.hobbies.join(", ")}</div>
          </div>
        )}
      </div>

      <style jsx>{`
       html {
  -webkit-print-color-adjust: exact;
  print-color-adjust: exact;
  margin: 0;
}
      `}</style>
    </div>
  );
}
